<template>
  <component :is="'div'" name="termly-embed" data-id="24075ecd-23e0-4b41-a77f-5e8cf03e43e7" data-type="iframe" />
</template>
